import Icon from '../components/Icon.vue'

Icon.register({
  dumbbell: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M104 96H56C42.7 96 32 106.7 32 120V224H8C3.6 224 0 227.6 0 232V280C0 284.4 3.6 288 8 288H32V392C32 405.3 42.7 416 56 416H104C117.3 416 128 405.3 128 392V120C128 106.7 117.3 96 104 96zM632 224H608V120C608 106.7 597.3 96 584 96H536C522.7 96 512 106.7 512 120V392C512 405.3 522.7 416 536 416H584C597.3 416 608 405.3 608 392V288H632C636.4 288 640 284.4 640 280V232C640 227.6 636.4 224 632 224zM456 32H408C394.7 32 384 42.7 384 56V224H256V56C256 42.7 245.3 32 232 32H184C170.7 32 160 42.7 160 56V456C160 469.3 170.7 480 184 480H232C245.3 480 256 469.3 256 456V288H384V456C384 469.3 394.7 480 408 480H456C469.3 480 480 469.3 480 456V56C480 42.7 469.3 32 456 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dumbbell.js
// module id = yTVN
// module chunks = 144